var map = {
	"./audio-placeholder": 597,
	"./audio-placeholder.png": 597,
	"./avatar-missing": 265,
	"./avatar-missing.png": 265,
	"./avatar-missing.svg": 1059,
	"./header-missing": 384,
	"./header-missing.png": 384,
	"./soapbox-logo": 385,
	"./soapbox-logo-white": 386,
	"./soapbox-logo-white.svg": 386,
	"./soapbox-logo.svg": 385,
	"./video-placeholder": 598,
	"./video-placeholder.png": 598,
	"./void": 599,
	"./void.png": 599,
	"./web-push/web-push-icon_expand": 622,
	"./web-push/web-push-icon_expand.png": 622,
	"./web-push/web-push-icon_favourite": 623,
	"./web-push/web-push-icon_favourite.png": 623,
	"./web-push/web-push-icon_reblog": 624,
	"./web-push/web-push-icon_reblog.png": 624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1058;